import request from "../../utils/request";

export const state = {};

export const actions = {
  sendMail({ dispatch, commit }) {
    return request({
      url: appUrl + "/api/test/send-mail",
      callBack: (type, value) => {
        return value || null;
      },
    });
  },
};
